import Backbone from 'backbone';
import _ from 'underscore';
import { decorate } from '@bingads-webui/dialog';
import { InlineLocationRecommendation } from './view';

export class InlineLocationRecommendationDialog extends Backbone.View {
  initialize(options) {
    this.options = options;
    this.deps = options.deps;
    this.isRecommendationOperated = false;
    this.locationAdded = false;
    this.recommendations = [];
  }

  render() {
    const View = decorate(InlineLocationRecommendation, {
      title: this.deps.i18n.getString('Inline_Location_Recommendation_Dialog_Title'),
      position: 'center',
      width: 1050,
      maxWidth: 1050,
    });
    const viewOptions = {
      template: 'inlineTemplate',
      isCampaignLevelLocation: true,
      showRecommendationsOnMap: true,
      isExpanded: true,
      ...this.options,
    };
    this.view = new View(viewOptions).render();
    this.view.on('cancel', e => this.remove(e));
    this.view.on('add:locations', () => { this.locationAdded = true; });
    this.view.on('operate:recommendations', () => { this.isRecommendationOperated = true; });
    this.view.on('remove', () => {
      if (this.locationAdded) { // refresh when add locations
        this.trigger('refresh:recommendations');
      } else if (_.isEmpty(this.recommendations) && this.isRecommendationOperated) {
        this.trigger('refresh:recommendations');
      }
    });
    this.view.on('update:recommendations', (recommendations) => {
      this.recommendations = recommendations;
      if (_.size(recommendations) === 0) { // if no recommendations, remove dialog
        this.remove();
      }
    });
    return this;
  }

  remove() {
    if (this.view) {
      this.view.remove();
    }
    super.remove();
  }
}
